(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/objectSpread", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/defineProperty", "events", "noform", "./defaultQuery"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/objectSpread"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/defineProperty"), require("events"), require("noform"), require("./defaultQuery"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.objectSpread, global.asyncToGenerator, global.classCallCheck, global.createClass, global.defineProperty, global.events, global.noform, global.defaultQuery);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _regenerator, _objectSpread2, _asyncToGenerator2, _classCallCheck2, _createClass2, _defineProperty2, _events, _noform, _defaultQuery) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _events = _interopRequireDefault(_events);
  _defaultQuery = _interopRequireDefault(_defaultQuery);

  var noop = function noop() {};

  var GridCore =
  /*#__PURE__*/
  function () {
    function GridCore() {
      var _this = this;

      var _props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      (0, _classCallCheck2.default)(this, GridCore);
      (0, _defineProperty2.default)(this, "setDataSource", function (dataSource) {
        // 设置dataSource，dataSource模式下需要改变分页数据
        _this.dataSource = dataSource || [];

        if (_this.mode === 'dataSource') {
          _this.setPageData({
            total: _this.dataSource.length,
            currentPage: 1
          });

          _this.refreshPagination();
        }

        _this.resetPage();

        _this.refreshTable();
      });
      (0, _defineProperty2.default)(this, "refresh", function () {
        _this.search();
      });
      (0, _defineProperty2.default)(this, "search", function () {
        _this.resetPage();

        _this.fetch();
      });
      (0, _defineProperty2.default)(this, "refreshTable", function () {
        // 刷新表格数据
        _this.emitter.emit('refresh');
      });
      (0, _defineProperty2.default)(this, "refreshPagination", function () {
        // 刷新分页数据
        _this.emitter.emit('pagination_refresh');
      });
      (0, _defineProperty2.default)(this, "resetPage", function () {
        // 重置分页数据，常用于重新搜索或API重置时
        _this.currentPage = 1;
      });
      (0, _defineProperty2.default)(this, "getDataSource", function () {
        // 通用的获取列表数据的方法
        if (_this.mode === 'url' || _this.mode === 'query') {
          return _this.dataSource;
        } // 获取dataSource模式下的当前列表数据


        var pageSize = _this.pageSize,
            total = _this.total,
            currentPage = _this.currentPage;
        var startIdx = (currentPage - 1) * pageSize;
        var endIdx = startIdx + pageSize;
        return _this.dataSource.slice(startIdx, endIdx);
      });
      (0, _defineProperty2.default)(this, "setCurrentPage", function (currentPage) {
        // 分页器跳转页面时使用
        _this.currentPage = currentPage;

        if (_this.mode === 'dataSource') {
          // dataSource模式下，直接更新表格
          _this.refreshPagination();

          _this.refreshTable();
        } else {
          _this.fetch(); // 直接请求数据

        }
      });
      (0, _defineProperty2.default)(this, "fetch",
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var pageData, filterData, params, cp, ps, queryParams, result, _ref2, dataList, total, pageSize, currentPage;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.mode === 'dataSource')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                pageData = _this.getPageData(); // 分页数据

                filterData = _this.getFilterData(); // 搜索数据

                params = _this.getParams();
                cp = pageData.currentPage, ps = pageData.pageSize;
                if (_this.formatFilter) filterData = _this.formatFilter(filterData); // 前置格式化
                // 请求格式

                queryParams = {
                  json: (0, _objectSpread2.default)({}, filterData, params, {
                    currentPage: cp,
                    pageSize: ps,
                    sort: {}
                  }),
                  _t: new Date().getTime()
                };
                _this.isLoading = true;

                _this.refreshTable(); // 默认流程，包含前置格式化和结果格式化


                result = null;
                if (_this.formatBefore) queryParams = _this.formatBefore(queryParams); // 前置格式化
                // 异常流，需要保证请求方法失败时会抛出异常

                _context.prev = 12;
                _context.next = 15;
                return _this.query(queryParams, _this.url, _this.method);

              case 15:
                result = _context.sent;
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](12);

                _this.onError(_context.t0);

              case 21:
                if (_this.formatAfter) result = _this.formatAfter(result); // 后置格式化

                _this.isLoading = false; // 数据更新

                _ref2 = result || {}, dataList = _ref2.dataList, total = _ref2.total, pageSize = _ref2.pageSize, currentPage = _ref2.currentPage;

                _this.setDataSource(dataList);

                _this.setMultipleData(result);

                _this.setPageData({
                  total: total,
                  pageSize: pageSize,
                  currentPage: currentPage
                }); // 触发渲染


                _this.refreshTable();

                _this.refreshPagination();

                _this.willUpdate();

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[12, 18]]);
      })));
      (0, _defineProperty2.default)(this, "setMultipleData", function (multipleData) {
        // 为多实体table设计
        _this.multipleData = multipleData;
      });
      (0, _defineProperty2.default)(this, "getMultipleData", function () {
        return _this.multipleData;
      });
      (0, _defineProperty2.default)(this, "clearFilterData", function () {
        // 清空查询
        _this.resetPage();

        _this.resetFilterData();

        _this.fetch();
      });
      (0, _defineProperty2.default)(this, "getFilterData", function () {
        // 获取搜索数据
        var filterData = _this.filterCore.getValues();

        var result = {};
        Object.keys(filterData).forEach(function (key) {
          if ([null, undefined].indexOf(filterData[key]) === -1) {
            result[key] = filterData[key];
          }
        });
        return result;
      });
      (0, _defineProperty2.default)(this, "setFilterData", function (filterData) {
        // 设置搜索数据
        _this.filterCore.setValues(filterData);
      });
      (0, _defineProperty2.default)(this, "resetFilterData", function () {
        // 重置搜索数据
        _this.filterCore.reset();
      });
      (0, _defineProperty2.default)(this, "setPageData", function (props) {
        // merge型设置分页数据
        var pageSize = props.pageSize,
            total = props.total,
            currentPage = props.currentPage;
        if ('pageSize' in props && !isNaN(pageSize)) _this.pageSize = pageSize;
        if ('total' in props && !isNaN(total)) _this.total = total;
        if ('currentPage' in props && !isNaN(currentPage)) _this.currentPage = currentPage < 1 ? 1 : currentPage;
      });
      (0, _defineProperty2.default)(this, "getPageData", function () {
        // 获取分页数据
        var pageSize = _this.pageSize,
            total = _this.total,
            currentPage = _this.currentPage;
        return {
          pageSize: pageSize,
          total: total,
          currentPage: currentPage
        };
      });
      (0, _defineProperty2.default)(this, "setParams", function (params) {
        if (['url', 'query'].indexOf(_this.mode) >= 0) {
          _this.params = params || {};
        }
      });
      (0, _defineProperty2.default)(this, "setUrl", function (url) {
        if (['url', 'query'].indexOf(_this.mode) >= 0) {
          _this.url = url;
        }
      });
      (0, _defineProperty2.default)(this, "getParams", function () {
        // 获取url参数
        var params = _this.params;
        return params;
      });
      this.initProps(_props);
      var formConfig = {};

      if (this.filterConfig) {
        formConfig = (0, _objectSpread2.default)({}, this.filterConfig || {});
      }

      if (this.defaultFilterValues) {
        formConfig.initValues = this.defaultFilterValues;
      }

      this.filterCore = new _noform.FormCore(formConfig); // 搜索的核心，基于noform实现

      this.emitter = new _events.default(); // 全局的事件总线
    }

    (0, _createClass2.default)(GridCore, [{
      key: "launch",
      value: function launch() {
        if (this.autoLoad && ['url', 'query'].indexOf(this.mode) !== -1) {
          this.fetch();
        }
      }
    }, {
      key: "updateProps",
      value: function updateProps(props) {
        if (!props) {
          throw new Error('props is null!!!');
        }

        this.resetPage();
        this.resetFilterData();
        this.initProps(props);
        this.fetch();
      }
    }, {
      key: "initProps",
      value: function initProps() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var dataSource = props.dataSource,
            query = props.query,
            url = props.url,
            method = props.method,
            params = props.params,
            pageSize = props.pageSize,
            currentPage = props.currentPage,
            total = props.total,
            _props$defaultQuery = props.defaultQuery,
            defaultQuery = _props$defaultQuery === void 0 ? _defaultQuery.default : _props$defaultQuery,
            onError = props.onError,
            _props$autoLoad = props.autoLoad,
            autoLoad = _props$autoLoad === void 0 ? true : _props$autoLoad,
            formatBefore = props.formatBefore,
            formatAfter = props.formatAfter,
            formatFilter = props.formatFilter,
            defaultFilterValues = props.defaultFilterValues,
            multiple = props.multiple,
            filterConfig = props.filterConfig,
            willUpdate = props.willUpdate;
        if ('dataSource' in props && dataSource) this.mode = 'dataSource'; // priority: low(1)

        if ('url' in props && url) this.mode = 'url'; // priority: middle(10)

        if ('query' in props && query) this.mode = 'query'; // priority: high(100)

        this.autoLoad = autoLoad; // 初始直接发起请求

        this.dataSource = dataSource || []; // 列表数据

        this.url = url; // 请求url

        this.params = params || {}; // 请求url的param

        this.method = method || 'get'; // 请求url的param

        this.query = query || defaultQuery; // 自定义请求方法,默认适用url模式

        this.pageSize = pageSize || 10; // 分页数据

        this.currentPage = currentPage || 1; // 当前页数

        this.total = total || 0; // 总数据条目数

        this.isLoading = false; // 当前加载数据状态: true | false

        this.onError = onError || noop;
        this.formatBefore = formatBefore;
        this.formatAfter = formatAfter;
        this.formatFilter = formatFilter;
        this.defaultFilterValues = defaultFilterValues;
        this.filterConfig = filterConfig;
        this.multipleData = dataSource; // 多实体数据

        this.multiple = multiple || false; // 多实体模式

        this.willUpdate = willUpdate || noop;
      }
    }]);
    return GridCore;
  }();

  _exports.default = GridCore;
});